/*
 *   File : download-button.js
 *   Author : https://evoqins.com
 *   Description : Download button component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { Icon } from "../Icon";

import Loader from "../../Assets/loader-dark.gif";

const DownloadButton = (props) => {
    return (
        <div className={`${props.disabled === true ? "pe-none opacity-50" : ""} ${props.loader ? "pe-none" : ""} e-border-1px-indigo e-border-radius-8 padding-10px-all cursor-pointer`}
            onClick={props.onClick} >
            {props.loader ?
                <img src={Loader}
                    width={19}
                    className='d-flex'
                    alt='loader' />
                :
                <Icon icon="download-icon"
                    className="d-flex"
                    size={19}
                />
            }
        </div>
    )
}

export default DownloadButton;